import { render } from "./VehicleAuctionImages.vue?vue&type=template&id=1dad8bfb"
import script from "./VehicleAuctionImages.vue?vue&type=script&lang=js"
export * from "./VehicleAuctionImages.vue?vue&type=script&lang=js"

import "./VehicleAuctionImages.vue?vue&type=style&index=0&id=1dad8bfb&lang=css"
script.render = render

export default script